import { SelectControllerProps } from '../SelectController';
import { BookingRequestsFiltersState } from './models';

export const SPECIALTIES_OPTIONS = Object.keys(window.SPECIALTIES).map((key) => ({
  value: key,
  label: window.SPECIALTIES[key],
}));

export const BOOKING_STATUS_OPTIONS = Object.keys(window.BOOKING_REQUEST_STATUS).map((key) => ({
  value: key,
  label: window.BOOKING_REQUEST_STATUS[key],
}));

export const defaultFilter: BookingRequestsFiltersState = {
  search: '',
  healthcareFacility: [],
  specialties: [],
  status: [],
  shiftDate: ['', ''],
  sortDirection: 'asc',
  sortBy: 'created_at',
};

export enum SortBy {
  CREATED_AT = 'created_at',
  UPDATED_AT = 'updated_at',
  FACILITY_NAME = 'healthcare_facility__name',
  STATUS = 'status',
  HEALTHCARE_REP_LAST_NAME = 'healthcare_entity_rep__user__last_name',
  FIRST_SHIFT = 'first_shift',
  LAST_SHIFT = 'last_shift',
  SHIFT_COUNT = 'shift_count',
  TOTAL_PAYMENT = 'total_payment',
  SPECIALITY = 'provider__specialties',
  PROVIDER = 'provider__last_name',
  CODE = 'code',
}

export const PROVIDER_SORT_OPTIONS = (): SelectControllerProps['options'] => [
  { label: 'Date Created', value: SortBy.CREATED_AT },
  { label: 'Date Updated', value: SortBy.UPDATED_AT },
  { label: 'Facility', value: SortBy.FACILITY_NAME },
  { label: 'Shift Status', value: SortBy.STATUS },
  { label: 'Healthcare Representative', value: SortBy.HEALTHCARE_REP_LAST_NAME },
  { label: 'First Shift', value: SortBy.FIRST_SHIFT },
  { label: 'Last Shift', value: SortBy.LAST_SHIFT },
  { label: 'Shift Count', value: SortBy.SHIFT_COUNT },
  { label: 'Total Payment', value: SortBy.TOTAL_PAYMENT },
  { label: 'Speciality', value: SortBy.SPECIALITY },
  { label: 'Code', value: SortBy.CODE },
];

export const HCO_SORT_OPTIONS = (): SelectControllerProps['options'] => [
  { label: 'Date Created', value: SortBy.CREATED_AT },
  { label: 'Date Updated', value: SortBy.UPDATED_AT },
  { label: 'Facility', value: SortBy.FACILITY_NAME },
  { label: 'Provider', value: SortBy.PROVIDER },
  { label: 'First Shift', value: SortBy.FIRST_SHIFT },
  { label: 'Last Shift', value: SortBy.LAST_SHIFT },
  { label: 'Shift Count', value: SortBy.SHIFT_COUNT },
  { label: 'Total Payment', value: SortBy.TOTAL_PAYMENT },
  { label: 'Speciality', value: SortBy.SPECIALITY },
  { label: 'Code', value: SortBy.CODE },
];

export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
